import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Spinner, Heading, Button, useToast } from "@chakra-ui/react";
import SignalCreator from "./SignalCreator";
import Navbar from "./Navbar";
import ProductSignalSelect from "./ProductSignalSelect";

export const fetchProduct = async (code) => {
  const response = await fetch(`https://poc.mrc.ai/${code}/api/product`);
  if (!response.ok) {
    throw new Error(`Failed to fetch product for code: ${code}`);
  }
  const json = await response.json();
  console.log("Fetched product data:", json);
  return Array.isArray(json) ? json[0] : json; // ✅ unwrap the array
};

const SignalCreatorPage = () => {
  const { productCode, dealId } = useParams();
  const [product, setProduct] = useState(null);
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();

    useEffect(() => {
      fetchProduct(productCode).then(setProduct);
    }, [productCode]);

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        const res = await fetch(`https://poc.mrc.ai/xol/api/deals/${dealId}`);
        const data = await res.json();
        setDeal(data);
      } catch (err) {
        toast({ title: "Failed to load deal", status: "error" });
      } finally {
        setLoading(false);
      }
    };
    fetchDeal();
  }, [productCode, dealId]);

  if (loading) return <Spinner size="xl" />;

  return (
    <Box position="relative" width="100%" minHeight="100vh">
      <Navbar />
      <SignalCreator contractInstance={deal} product={product} productTemplate={null}/>

    </Box>
  );
};

export default SignalCreatorPage;
